"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formDataWithAccessTokenHeaders = exports.addAccessTokenToHeaders = void 0;
const addAccessTokenToHeaders = (headerProps) => {
    var _a;
    const accessToken = (_a = headerProps.authToken) !== null && _a !== void 0 ? _a : '';
    if (accessToken.length < 1) {
        console.warn('Expected access token to not be empty but it is');
    }
    return ({
        headers: {
            authorization: `Bearer ${accessToken}`,
        }
    });
};
exports.addAccessTokenToHeaders = addAccessTokenToHeaders;
const formDataWithAccessTokenHeaders = (headerProps) => {
    const onlyAccessToken = (0, exports.addAccessTokenToHeaders)(headerProps);
    return (Object.assign(Object.assign({}, onlyAccessToken), { headers: Object.assign(Object.assign({}, onlyAccessToken.headers), { 'Content-Type': 'multipart/form-data; boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW' }) }));
};
exports.formDataWithAccessTokenHeaders = formDataWithAccessTokenHeaders;
